'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VideoRemote = undefined;

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _helpers = require('./helpers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VideoRemote = exports.VideoRemote = {
    fetchStreamId: function fetchStreamId(_ref) {
        var authToken = _ref.authToken,
            catalogId = _ref.catalogId,
            deployment = _ref.deployment;
        return new _promise2.default(function (resolve, reject) {
            var request = (0, _helpers.makeGet)({
                apiPath: 'status/' + catalogId,
                authToken: authToken,
                deployment: deployment,
                path: '<STREAM-MANAGER>'
            });

            request.end(function (err, response) {
                return (0, _helpers.handleResponse)({
                    err: err,
                    reject: reject,
                    resolve: resolve,
                    response: response
                });
            });
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/remote/video.js
// module id = xM1E
// module chunks = 60